import {
  TriangleAlert,
  CircleCheckBig,
  CircleX,
  CircleAlert,
  CircleCheck,
} from "lucide-react";

import styles from "./AlertaModal.module.scss";

interface AlertModalProps {
  open: boolean;
  type?: "warning" | "success" | "error" | "info";
  title: string;
  description: string;
  kycValidado?: boolean;
  onClose: () => void;
  onContinuar: () => void;
}

export const AlertModal = ({
  open,
  type = "warning",
  title,
  description,
  kycValidado,
  onClose,
  onContinuar,
}: AlertModalProps) => {
  if (!open) {
    return null;
  }

  const renderIcon = () => {
    switch (type) {
      case "success":
        return <CircleCheckBig />;

      case "error":
        return <CircleX />;

      case "info":
        return <CircleAlert />;

      default:
        return <TriangleAlert />;
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={`${styles.icon} ${styles[type]}`}>
          {renderIcon()}
        </div>

        <h2>{title}</h2>

        <p>{description}</p>

        {kycValidado !== undefined && (
          <div className={styles.lista}>
            <Item
              ok={kycValidado}
              texto={
                kycValidado
                  ? "Conta validada"
                  : "Validação da conta pendente"
              }
            />
          </div>
        )}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
          >
            Agora não
          </button>

          <button
            type="button"
            className={styles.confirmButton}
            onClick={onContinuar}
          >
            Validar conta
          </button>
        </div>
      </div>
    </div>
  );
};

interface ItemProps {
  ok: boolean;
  texto: string;
}

function Item({ ok, texto }: ItemProps) {
  return (
    <div className={styles.item}>
      {ok ? (
        <CircleCheck className={styles.success} />
      ) : (
        <CircleX className={styles.error} />
      )}

      <span>{texto}</span>
    </div>
  );
}